import { useEffect, useState } from "react";

function secondsUntil(deadline: number | null): number {
  return deadline === null ? 0 : Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
}

/** Whole seconds until `deadline` (a Date.now() timestamp), updated every second; 0 once it has passed. */
export function useSecondsLeft(deadline: number | null): number {
  const [state, setState] = useState(() => ({ deadline, seconds: secondsUntil(deadline) }));
  if (state.deadline !== deadline) {
    // A new deadline restarts the count in this render instead of one tick later.
    setState({ deadline, seconds: secondsUntil(deadline) });
  }

  useEffect(() => {
    if (deadline === null) return;
    const timer = window.setInterval(() => setState({ deadline, seconds: secondsUntil(deadline) }), 1000);
    return () => window.clearInterval(timer);
  }, [deadline]);

  return state.seconds;
}

/** 65 -> "1:05", 3600 -> "60:00". */
export function formatCountdown(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}
